import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { motion } from "framer-motion";
import {
  Container,
    Flex,
    Box,
    Heading,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    useDisclosure,
    Button,
    Center
} from '@chakra-ui/react';

import { ChevronRightIcon } from '@chakra-ui/icons';

import styled from '@emotion/styled'
import { PrismicRichText } from "@prismicio/react"

const GridContainer = styled.div`
    display: grid; 
    grid-template-columns: repeat(4, 1fr); 
    grid-template-rows: repeat(2, 1fr); 
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(4, 1fr);
    }
`
const SquareImageOne = styled(Box)`
    cursor: pointer;
    grid-area: 1 / 1 / 2 / 2;
    > div {
        height: 100%
    }
    @media (max-width: 768px) {
        grid-area: 1 / 1 / 2 / 2;
    }
`
const SquareImageTwo = styled(Box)`
    cursor: pointer;
    grid-area: 1 / 2 / 2 / 3;
    > div {
        height: 100%
    }
    @media (max-width: 768px) {
        grid-area: 1 / 2 / 2 / 3;
    }
`

const SquareImageThree = styled(Box)`
    cursor: pointer;
    grid-area: 1 / 3 / 2 / 4;
    > div {
        height: 100%
    }
    @media (max-width: 768px) {
        grid-area: 3 / 1 / 4 / 2;
    }
`

const LandscapeImage = styled(Box)`
    cursor: pointer;
    grid-area: 2 / 1 / 3 / 3;
    @media (max-width: 768px) {
        grid-area: 2 / 1 / 3 / 3;
    }
`

const SquareImageFour = styled(Box)`
    cursor: pointer;
    grid-area: 2 / 3 / 3 / 4;
    > div {
        height: 100%
    }
    @media (max-width: 768px) {
        grid-area: 4 / 1 / 5 / 2;
    }
`

const PortraitImage = styled(Box)`
    cursor: pointer;
    height: 100%;
    grid-area: 1 / 4 / 3 / 5;
    > div  {
        height: 100%
    }
    @media (max-width: 768px) {
        grid-area: 3 / 2 / 5 / 3;
    }   
`

const ImageLabel = (props) => {
    return (
        <Box position="absolute" bottom="1rem" w="100%">
            <Heading as="h3" color="white" fontSize={["2xl", "4xl"]} textAlign="center" mb="12" textShadow="2px 2px 2px #00000089">
                {props.label}
            </Heading>
        </Box>
    )
}

export default function GridTypeOne({ slice }) {

    console.log(slice)

    const container = {
        hidden: { opacity: 0 },
        viewport: { once: true },
        show: {
        viewport: { once: true },
          opacity: 1,
          transition: {
            ease: "easeOut", 
            duration: '1.75',
            staggerChildren: 0.25,
          }
        }
      }

    const item = {
      hidden: { opacity: 0 },
      show: { opacity: 1 },
      whileHover: { scale: 1.05 },
    }

    function SquareImageOneModal() {
      const { isOpen, onOpen, onClose } = useDisclosure();
      return (
        <>
          <SquareImageOne
            position="relative"
            as={motion.div}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            variants={item}
          >
            <Box onClick={onOpen} h="100%">
              <Box h="100%">
                {slice.primary.square_image_1.localFile ? (
                  <GatsbyImage
                    image={getImage(slice.primary.square_image_1.localFile)}
                    alt={slice.primary.square_image_1_alt}
                    imgStyle={{ borderRadius: "2rem" }}
                  />
                ) : (
                  <Flex
                    w="100%"
                    h="100%"
                    bg={
                      slice.primary.square_image_1_color === "Blue"
                        ? "blue.500"
                        : slice.primary.square_image_1_color === "Green"
                        ? "sage.500"
                        : slice.primary.square_image_1_color === "Yellow"
                        ? "vintage-yellow.600"
                        : slice.primary.square_image_1_color === "Orange"
                        ? "poppy.500"
                        : "blue.500"
                    }
                    style={{ borderRadius: "2rem" }}
                  />
                )}
                <ImageLabel label={slice.primary.square_image_1_label} />
              </Box>
            </Box>
          </SquareImageOne>

          <Modal isOpen={isOpen} onClose={onClose} size="xl">
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>{slice.primary.square_image_1_label}</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <PrismicRichText
                  field={slice.primary.square_image_1_content.richText}
                  
                />
                <Center>
                  {slice.primary.square_image_1_link_label && (
                    <Button
                      variant="ghost"
                      color="blue.500"
                      as={GatsbyLink}
                      to={slice.primary.square_image_1_link.url}
                      state={{
                        eatListingTag: slice.primary.square_image_1_tag,
                      }}
                    >
                      {slice.primary.square_image_1_link_label}{" "}
                      <ChevronRightIcon />
                    </Button>
                  )}
                </Center>
              </ModalBody>
            </ModalContent>
          </Modal>
        </>
      );
    }

      function SquareImageTwoModal() {
        const { isOpen, onOpen, onClose } = useDisclosure();
        return (
          <>
            <SquareImageTwo
              position="relative"
              as={motion.div}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={item}
            >
              <Box onClick={onOpen} h="100%">
                <Box h="100%">
                  {slice.primary.square_image_2.localFile ? (
                    <GatsbyImage
                      image={getImage(slice.primary.square_image_2.localFile)}
                      alt={slice.primary.square_image_2_alt}
                      imgStyle={{ borderRadius: "2rem" }}
                    />
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      bg={
                        slice.primary.square_image_2_color === "Blue"
                          ? "blue.500"
                          : slice.primary.square_image_2_color === "Green"
                          ? "sage.500"
                          : slice.primary.square_image_2_color === "Yellow"
                          ? "vintage-yellow.600"
                          : slice.primary.square_image_2_color === "Orange"
                          ? "poppy.500"
                          : "blue.400"
                      }
                      style={{ borderRadius: "2rem" }}
                    />
                  )}
                  <ImageLabel label={slice.primary.square_image_2_label} />
                </Box>
              </Box>
            </SquareImageTwo>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>{slice.primary.square_image_2_label}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <PrismicRichText field={slice.primary.square_image_2_content.richText}
                    
                  />
                  <Center>
                    {slice.primary.square_image_2_link_label && (
                      <Button
                        variant="ghost"
                        as={GatsbyLink}
                        to={slice.primary.square_image_2_link.url}
                        state={{
                          eatListingTag: slice.primary.square_image_2_tag,
                        }}
                      >
                        {slice.primary.square_image_2_link_label}{" "}
                        <ChevronRightIcon />
                      </Button>
                    )}
                  </Center>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        );
      }

      function SquareImageThreeModal() {
        const { isOpen, onOpen, onClose } = useDisclosure();
        return (
          <>
            <SquareImageThree
              position="relative"
              as={motion.div}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={item}
            >
              <Box onClick={onOpen} h="100%">
                <Box h="100%">
                  {slice.primary.square_image_3.localFile ? (
                    <GatsbyImage
                      image={getImage(slice.primary.square_image_3.localFile)}
                      alt={slice.primary.square_image_3_alt}
                      imgStyle={{ borderRadius: "2rem" }}
                    />
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      bg={
                        slice.primary.square_image_3_color === "Blue"
                          ? "blue.500"
                          : slice.primary.square_image_3_color === "Green"
                          ? "sage.500"
                          : slice.primary.square_image_3_color === "Yellow"
                          ? "vintage-yellow.600"
                          : slice.primary.square_image_3_color === "Orange"
                          ? "poppy.500"
                          : "blue.400"
                      }
                      style={{ borderRadius: "2rem" }}
                    />
                  )}
                  <ImageLabel label={slice.primary.square_image_3_label} />
                </Box>
              </Box>
            </SquareImageThree>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>{slice.primary.square_image_3_label}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <PrismicRichText field={slice.primary.square_image_3_content.richText}
                    
                  />
                  <Center>
                    {slice.primary.square_image_3_link_label && (
                      <Button
                        variant="ghost"
                        as={GatsbyLink}
                        to={slice.primary.square_image_3_link.url}
                        state={{
                          eatListingTag: slice.primary.square_image_3_tag,
                        }}
                      >
                        {slice.primary.square_image_3_link_label}{" "}
                        <ChevronRightIcon />
                      </Button>
                    )}
                  </Center>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        );
      }

      function LandscapeImageModal() {
        const { isOpen, onOpen, onClose } = useDisclosure();
        return (
          <>
            <LandscapeImage
              position="relative"
              as={motion.div}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={item}
            >
              <Box onClick={onOpen} h="100%">
                <Box h="100%">
                  {slice.primary.landscape_image.localFile ? (
                    <GatsbyImage
                      image={getImage(slice.primary.landscape_image.localFile)}
                      alt={slice.primary.square_image_3_alt}
                      imgStyle={{ borderRadius: "2rem" }}
                    />
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      bg={
                        slice.primary.landscape_image_color === "Blue"
                          ? "blue.500"
                          : slice.primary.landscape_image_color === "Green"
                          ? "sage.500"
                          : slice.primary.landscape_image_color === "Yellow"
                          ? "vintage-yellow.600"
                          : slice.primary.landscape_image_color === "Orange"
                          ? "poppy.500"
                          : "blue.400"
                      }
                      style={{ borderRadius: "2rem" }}
                    />
                  )}
                  <ImageLabel label={slice.primary.landscape_image_label} />
                </Box>
              </Box>
            </LandscapeImage>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>{slice.primary.landscape_image_label}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <PrismicRichText field={slice.primary.landscape_image_content.richText}
                    
                  />
                  <Center>
                    {slice.primary.landscape_image_link_label && (
                      <Button
                        variant="ghost"
                        as={GatsbyLink}
                        to={slice.primary.landscape_image_link.url}
                        state={{
                          eatListingTag: slice.primary.landscape_image_tag,
                        }}
                      >
                        {slice.primary.landscape_image_link_label}{" "}
                        <ChevronRightIcon />
                      </Button>
                    )}
                  </Center>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        );
      }

      function SquareImageFourModal() {
        const { isOpen, onOpen, onClose } = useDisclosure();
        return (
          <>
            <SquareImageFour
              position="relative"
              as={motion.div}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={item}
            >
              <Box onClick={onOpen} h="100%">
                <Box h="100%">
                  {slice.primary.square_image_4.localFile ? (
                    <GatsbyImage
                      image={getImage(slice.primary.square_image_4.localFile)}
                      alt={slice.primary.square_image_4_alt}
                      imgStyle={{ borderRadius: "2rem" }}
                    />
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      bg={
                        slice.primary.square_image_4_color === "Blue"
                          ? "blue.500"
                          : slice.primary.square_image_4_color === "Green"
                          ? "sage.500"
                          : slice.primary.square_image_4_color === "Yellow"
                          ? "vintage-yellow.600"
                          : slice.primary.square_image_4_color === "Orange"
                          ? "poppy.500"
                          : "blue.400"
                      }
                      style={{ borderRadius: "2rem" }}
                    />
                  )}
                  <ImageLabel label={slice.primary.square_image_4_label} />
                </Box>
              </Box>
            </SquareImageFour>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>{slice.primary.square_image_4_label}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <PrismicRichText field={slice.primary.square_image_4_content.richText}
                    
                  />
                  <Center>
                    {slice.primary.square_image_4_link_label && (
                      <Button
                        variant="ghost"
                        as={GatsbyLink}
                        to={slice.primary.square_image_4_link.url}
                        state={{
                          eatListingTag: slice.primary.square_image_4_tag,
                        }}
                      >
                        {slice.primary.square_image_4_link_label}{" "}
                        <ChevronRightIcon />
                      </Button>
                    )}
                  </Center>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        );
      }

      function PortraitImageModal() {
        const { isOpen, onOpen, onClose } = useDisclosure();
        return (
          <>
            <PortraitImage
              position="relative"
              as={motion.div}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              variants={item}
            >
              <Box onClick={onOpen} h="100%">
                <Box h="100%">
                  {slice.primary.portrait_image.localFile ? (
                    <GatsbyImage
                      image={getImage(slice.primary.portrait_image.localFile)}
                      alt={slice.primary.portrait_image_alt}
                      imgStyle={{ borderRadius: "2rem" }}
                    />
                  ) : (
                    <Flex
                      w="100%"
                      h="100%"
                      bg={
                        slice.primary.portrait_image_color === "Blue"
                          ? "blue.500"
                          : slice.primary.portrait_image_color === "Green"
                          ? "sage.500"
                          : slice.primary.portrait_image_color === "Yellow"
                          ? "vintage-yellow.600"
                          : slice.primary.portrait_image_color === "Orange"
                          ? "poppy.500"
                          : "blue.400"
                      }
                      style={{ borderRadius: "2rem" }}
                    />
                  )}
                  <ImageLabel label={slice.primary.portrait_image_label} />
                </Box>
              </Box>
            </PortraitImage>

            <Modal isOpen={isOpen} onClose={onClose} size="xl">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>{slice.primary.portrait_image_label}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <PrismicRichText field={slice.primary.portrait_image_content.richText}
                    
                  />
                  <Center>
                    {slice.primary.portrait_image_link_label && (
                      <Button
                        variant="ghost"
                        as={GatsbyLink}
                        to={slice.primary.portrait_image_link.url}
                        state={{
                          eatListingTag: slice.primary.portrait_image_tag,
                        }}
                      >
                        {slice.primary.portrait_image_link_label}{" "}
                        <ChevronRightIcon />
                      </Button>
                    )}
                  </Center>
                </ModalBody>
              </ModalContent>
            </Modal>
          </>
        );
      }

    return (
      <Container maxW="container.xl">
        <Box my="2">
            <GridContainer variants={container} initial="hidden" whileInView="show" as={motion.div} viewport={{ once: true }}>
                        
                <SquareImageOneModal />  
    
                <SquareImageTwoModal />
               
                <SquareImageThreeModal />                        
                        
                <LandscapeImageModal />
                        
                <SquareImageFourModal />
                        
                <PortraitImageModal />
    
            </GridContainer>
        </Box>
        </Container>
    )
}